module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_c('b', [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('i', [_vm._v("UNCLE JOHN’S BATHROOM®"), _c('br'), _vm._v(" READER WISE UP!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', [_vm._v("Copyright © 2009 Portable Press")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', [_vm._v("All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other noncommercial uses permitted by copyright law.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', [_vm._v("Portable Press/The Bathroom Readers’ Institute")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt2"
  }, [_c('span', [_vm._v("An imprint of Printers Row Publishing Group")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt2"
  }, [_vm._v("10350 Barnes Canyon Road, Suite 100")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt2"
  }, [_vm._v("San Diego, CA 92121")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt2"
  }, [_c('span', [_vm._v("www.bathroomreader.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt2"
  }, [_c('span', [_vm._v("e-mail: mail@bathroomreader.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', [_vm._v("Printers Row Publishing Group is a division of Readerlink Distribution Services, LLC.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt2"
  }, [_c('span', [_vm._v("The Portable Press, Bathroom Readers’ Institute, and Uncle John’s Bathroom Reader names and logos are trademarks of Readerlink Distribution Services, LLC.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', [_vm._v("All correspondence concerning the content of this book should be addressed to Portable Press/The Bathroom Readers’ Institute, Editorial Department, at the above address.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("eISBN: 978-1-60710-673-9")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("E-Book edition: October 2012")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8673887c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0